<template>
  <div class="flex flex-col mt-3">
    <Modal
      ref="districtSelectorModal"
      size="full"
      width="max"
      anchor="center">
      <template #title>Select District</template>
      <template #content>
        <form>
          <SearchForm
            v-model="search"
            @search="onSearch"
          />
        </form>
        <div class="flex flex-col p-2 bg-gray-200 rounded-md">
          <Spinner
            v-if="displayLoadingSpinner"
            message="Loading Districts"
            :size="16"
          />
          <div class="px-2 bg-blue-200 font-bold rounded-md"
            v-if="search">
            {{ search }}
          </div>
          <div
            v-for="district in filteredDistricts"
            :key="district.id">
            <div class="flex flex-row hover:bg-gray-100"
              :class="{
                'border-black': selectedDistrictId === district.id,
                'border-2': selectedDistrictId === district.id,
                'border-lg': selectedDistrictId === district.id,
                'border-0': selectedDistrictId !== district.id,
              }"
              @click="selectEntry(district.id)">
              <span class="px-2 w-32">
                {{ district.code }}
              </span>
              <span class="px-2 w-48 truncate">
                {{ district.partition.description }}
              </span>
              <span class="px-2 min-w-48 max-w-full">
                {{ district.name }}
              </span>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <Button class="rounded-md px-3 py-2 transition-colors shadow-sm"
          color="blue"
          @click="addValue">
          Add
        </Button>
      </template>
    </Modal>
  </div>
</template>


<script>
import Modal from '../../Modal.vue'
import Button from '../../Button.vue'
import Spinner from '../../Spinner.vue'
// import TextField from '../../formComponents/TextField.vue'
import SearchForm from '../../Search/SearchForm.vue'

import { filter } from 'lodash'

import userManagementService from '../../../services/pages/userManagement.js'

export default {
  components: {
    Modal,
    Button,
    Spinner,
    // TextField,
    SearchForm,
  },
  props: {},
  data() {
    return {
      districts: {},
      selectedDistrictId: undefined,

      displayLoadingSpinner: false,

      search: undefined,
      formValues: undefined,
    }
  },
  mounted() {
    userManagementService.registerSelectorModal(
      'district',
      () => {
        this.$refs['districtSelectorModal'].openModal()
        this.displayLoadingSpinner = true
        userManagementService.getConfigContent(['district', 'partition'])
          .then((data) => {
            this.displayLoadingSpinner = false
            this.districts = data['districts']
          })
      },
      () => {
        this.$refs['districtSelectorModal'].closeModal()
      },
    )
  },
  methods: {
    selectEntry(districtId) {
      this.selectedDistrictId = districtId
    },
    onSearch() {
      console.log('onSearch')
    },
    addValue() {
      userManagementService.closeSelectorModal('district', this.districts[this.selectedDistrictId])
      this.selectedDistrictId = undefined
    },
  },
  computed: {
    filteredDistricts() {
      if (this.search) {
        return filter(this.districts, (district) => {          
          return district.code?.toLowerCase().includes(this.search.toLowerCase()) ||
            district.name?.toLowerCase().includes(this.search.toLowerCase()) ||
            district.state?.toLowerCase().includes(this.search.toLowerCase()) ||
            district.partition?.description?.toLowerCase().includes(this.search.toLowerCase())
        })
      }
      else {
        return this.districts
      }
    }
  },
}
</script>
